module.exports = __webpack_public_path__ + "a4ff728f24fed83938ac159b8f21cc8c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/ST.svg
// module id = d4Mg
// module chunks = 0